import React, { useCallback, useEffect, useState } from 'react'
import db from '../../resources/db'
import { IonItem, IonMenu, IonHeader, IonToolbar, IonTitle, IonContent, IonList, IonListHeader, IonIcon, IonLabel, IonSearchbar, IonSelect, IonSelectOption } from '@ionic/react'
import { person, list, chevronBackCircle } from 'ionicons/icons'
import { loadingController, menuController } from '@ionic/core';
import { APPLINKS } from '../../resources/AppConst'

const PartyList = () => {
    const [CustomerList, setCustomerList] = useState([]);
    const [filteredList, setFilteredList] = useState([]);
    const [type , setType] = useState(1);

    const fetchList = useCallback(() => {
        let list = []
        db.ledger.where({ isCustomer: type }).toArray().then(res => {
            res.forEach(element => {
                if (!list.includes(element.customerName)) {
                    list.push(element.customerName)
                }
            });
            list.sort()
            setCustomerList(list)
            setFilteredList(list)
        })
    } , [type])

    // fetch the data first load
    useEffect(() => {
        fetchList()
        return () => {
            // cleanup
            setCustomerList([]);
            setFilteredList([]);
        }
    }, [fetchList])

    /** Search Customer Name */
    const search = async (q) => {
        if (q) {
            let query = q.toLowerCase()
            let list = CustomerList.filter((val => {
                return val.toLowerCase().indexOf(query) > -1;
            }))
            setFilteredList(list)
        }
        else {
            fetchList()
            console.log('none');
        }
    }
    return (
        <IonMenu menuId='LedgerMenu' contentId='main' type='overlay' >
            <IonHeader>
                <IonToolbar color='danger'>
                    <IonTitle>Billing Inc</IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent>
                <IonList>
                    <IonItem lines='none' routerLink='/'>
                        <IonIcon slot="start" icon={chevronBackCircle} />
                        <IonLabel>Back to Dashboard</IonLabel>
                    </IonItem>
                    <IonItem routerLink={APPLINKS.ledger}>
                        <IonIcon slot="start" icon={list} />
                        <IonLabel>Ledger</IonLabel>
                    </IonItem>
                    <IonListHeader>
                        <IonSelect interface='popover' id='list' value={type}  placeholder={`List (${filteredList.length})`} onIonChange={(e) => { setType(e.detail.value) }}>
                            <IonSelectOption value={1}>Customer List ({CustomerList.length}) </IonSelectOption>
                            <IonSelectOption value={0}>Purchase List ({CustomerList.length}) </IonSelectOption>
                        </IonSelect>
                    </IonListHeader>
                    <IonItem>
                        <IonSearchbar showCancelButton='focus' debounce={800} onIonCancel={() => {
                            fetchList()
                        }} onIonChange={(e) => search(e.target.value)}></IonSearchbar>
                    </IonItem>
                    {filteredList.length ? (
                        filteredList.map((customer, i) => {
                            let currentParty = sessionStorage.getItem('currentParty')
                            return (
                                <IonItem disabled={(customer === currentParty)}
                                    onClick={() => {
                                        loadingController.create({
                                            id: "ledgerLoad",
                                            message: "Loading...",
                                            mode: "md",
                                            spinner: "crescent",
                                            duration: 3000
                                        }).then(spin => {
                                            spin.present();
                                        });

                                        menuController.close()
                                    }}
                                    routerLink={`${APPLINKS.ledger}/${btoa(customer)}`}
                                    id='cli' className="clist" key={i} >
                                    <IonIcon slot='start' icon={person}></IonIcon>
                                    <IonLabel style={{ textTransform: 'capitalize' }}>{customer}</IonLabel>
                                </IonItem>)
                        })
                    ) : ('')}
                </IonList>
            </IonContent>
        </IonMenu>

    )
}

export default PartyList
